import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

const createCreditTraductionSchema = z.object({
  quantity: z.number(),
  remain: z.number(),
  souscriptionId: z.string().optional(),
  userId: z.string(),
});

export class CreateCreditTraductionDto extends createZodDto(createCreditTraductionSchema) {}
